import React, { createContext, useContext, ReactNode } from 'react';

interface SurveyPricesContextValue {
    isSaving: boolean;
    changedCount: number;
    hasAnyChanges: boolean;
    saveChanges: () => Promise<boolean>;
}

const SurveyPricesContext = createContext<SurveyPricesContextValue | null>(
    null,
);

interface SurveyPricesProviderProps {
    children: ReactNode;
    value: SurveyPricesContextValue;
}

export function SurveyPricesProvider({
    children,
    value,
}: SurveyPricesProviderProps) {
    return (
        <SurveyPricesContext.Provider value={value}>
            {children}
        </SurveyPricesContext.Provider>
    );
}

export function useSurveyPricesContext() {
    const context = useContext(SurveyPricesContext);
    if (!context) {
        throw new Error(
            'useSurveyPricesContext must be used within SurveyPricesProvider',
        );
    }
    return context;
}
